import styled from 'styled-components';
import { FlexboxProps, flexbox, PositionProps, position, LayoutProps, layout } from 'styled-system';

export const Nav = styled.nav<FlexboxProps & PositionProps & LayoutProps>(flexbox, position, layout, {
  display: 'flex',
});

Nav.defaultProps = {
  flexDirection: 'row',
};
